<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Excluir Dependentes do Plano
    </h1>
</header>
<main class="main__page">
    <section class="main__content__artigo">
        <h2 class="content__artigo__title">Importante Saber!</h2>
        <div class="content__aviso__artigo">
            <p>
                <b>1º</b> - A exclusão do PROSAÚDE II terá <b>efeito imediato e caráter irrevogável</b>, não admitindo a
                desistência e não estará mais coberto pelo plano, a partir do protocolo desta solicitação à Fundação
                Copel;
            </p>
            <p>
                <b>2º</b> - Qualquer utilização do plano de saúde (exame, cirurgia, etc.), mesmo que autorizada pela
                Fundação Copel, <b>não será realizada após a solicitação de exclusão</b>;
            </p>
            <p>
                <b>3º</b> - No caso de utilização do PROSAÚDE II <b>posteriormente ao protocolo de exclusão, o
                    Beneficiário Titular arcará com 100% do valor da despesa</b>, independente se o atendimento foi
                realizado em caráter de urgência/emergência ou eletivo;
            </p>
            <p>
                <b>4º</b> - <b>Para reingresso</b> no PROSAÚDE II, será necessário o preenchimento de um <b>novo pedido
                    de inscrição e de nova declaração de saúde</b>;
            </p>
            <p>
                <b>5º</b> - O <b>retorno ao PROSAÚDE II dentro dos 30 (trinta) dias</b>, contados a partir do protocolo
                da solicitação de exclusão, <b>ocorrerá sem cumprimento de carências</b>;
            </p>
            <p>
                <b>6º</b> - <b>Após os 30 (trinta) dias</b> do protocolo do pedido de exclusão, <b>será necessário
                    cumprimento das carências</b> previstas em Regulamento, <b>ou apresentação de carta de portabilidade
                    de outra operadora de plano de saúde</b>, desde que o plano seja correspondente aos planos da
                Fundação Copel;
            </p>
            <p>
                <b>7º</b> - A exclusão do PROSAÚDE II <b>acarretará a perda do direito à portabilidade de carências</b>
                (mudança de plano de saúde sem cumprimento de novos prazos de carência), caso não tenha sido este o
                motivo de seu pedido de cancelamento.
            </p>
        </div>
    </section>
    <section class="main__content__formulario">
        <div class="mb-4">
            <div class="justify-content-center">
                <h5 class="content__title__h3 mb-2">Dependentes a serem excluídos:</h5>
                <section
                    style="background: #f9f9f9; padding: 0.5rem 0rem;font-size: 0.875rem !important;line-height: 1.313rem;">
                    <div class="checkbox-beneficiaries" *ngFor="let item of beneficiaries">
                        <div class="col-12">
                            <div class="form-check" data-toggle="tooltip" title="{{titleTooltip}}">
                                <input type="checkbox" class="form-check-input" [disabled]="termschecked"
                                    id="check_{{item.idSegurado}}" (click)="checked($event)">
                                <label class="form-check-label" for="check_{{item.idSegurado}}">{{item.name}}</label>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>
    <blockquote class="col-12 aviso-excluir-dependente">
        Ao concordar em excluir, esse(s) dependente(s) terão o plano de saúde cancelado:
        <section class="aviso-excluir-dependente-pessoa">
            <p class="desc-info-list" *ngFor="let item of beneficiaries">
                <span *ngIf="item.selecionado">{{item.name}}</span>
            </p>
        </section>
    </blockquote>
    <section class="content-subcard">
        <p class="content__title__h3">O protocolo de cancelamento será enviado para os seguintes e-mails</p>
        <section class="content_descricao px-1 col-xl-5 col-md-10 col-sm-12">
            <p class="content_descricao__email" *ngFor="let item of emails;let i = index">
                <span class="content_descricao__email__valor">
                    <b>- </b> {{item | lowercase}}
                </span>
                <fa-icon class="content_descricao__btn" [icon]="faTrash" (click)=removeEmail(i)
                    *ngIf="emails.length > 1">
                </fa-icon>
            </p>
        </section>
    </section>
    <section class="main__content__formulario">
        <h3>Protocolo de exclusão:</h3>
        <form class="main__page__content__form" [formGroup]="formContact" (ngSubmit)="adicionarEmail()">
            <section class="content-form">
                <div class="form-group pr-0 pl-0 col-xl-6 col-md-7 col-sm-12">
                    <label class="content_formulario__cancelamento__label" for="exampleInputEmail1">Adicionar e-mail
                        alternativo</label>
                    <input aria-describedby="emailHelp" class="form-control" formControlName="email"
                        id="exampleInputEmail1" placeholder="Informe um e-mail" type="email col-8">
                    <small class="form-text text-muted content_formulario__cancelamento__aviso"
                        *ngIf="formContact.get('email')?.invalid && formContact.get('email')?.touched && formContact.get('email')?.value != null && formContact.get('email')?.value.length == 0">
                        O e-mail informado é inválido!
                    </small>
                </div>
                <div class="col-xl-2 col-md-5 col-sm-12 mt-2">
                    <button class="btn button-primary col-12" type="submit"
                        [disabled]="formContact.get('email')?.invalid">Adicionar</button>
                </div>
            </section>
            <div class="form-check formulario__cancelamento__checkbox">
                <input class="form-check-input" formControlName="confirm" id="exampleCheck1" type="checkbox"
                    [checked]="termschecked" [disabled]="!enableTerms"
                    (change)="termschecked = !termschecked; changeTitleTooltip();">
                <label class="form-check-label content_formulario__cancelamento__label" for="exampleCheck1">Estou ciente
                    e desejo prosseguir com o cancelamento do plano de saúde.</label>
            </div>
        </form>
    </section>
    <br>
    <br>
    <section class="col-12">
        <button class="btn button-primary" id="btn-cancelamento" (click)="confirmTerm()"
            [disabled]="!enableTerms || !termschecked || emails.length == 0 || this.loading" prevent-double-submit>
            Solicitar Exclusão
        </button>
    </section>
</main>